import * as yup from 'yup';

export const validationPasswordSchema = yup.object({
    password: yup
        .string()
        .required('Required')
        .oneOf([yup.ref('passwordconfirm'), null], 'Password not matched'),
    passwordconfirm: yup
        .string()
        .required('Required')
        .oneOf([yup.ref('password'), null], 'Password not matched'),
})

export const validationSchema = yup.object({
    username: yup
        .string()
        .required('Required'),
    firstname: yup
        .string()
        .required('Required'),
    lastname: yup
        .string()
        .required('Required'),
    // contactno: yup
    //     .number()
    //     .typeError("Only number")
    //     .required('Required')
    //     .test(
    //         "is-positive",
    //         "Please enter a positive number",
    //         (value) => value >= 0 && 1 / value !== -Infinity),
    email: yup
        .string()
        .email('Enter a valid email')
        .required('Required'),

    companyName: yup
        .string()
        .required('Required'),
    code: yup
        .string()
        .required('Required'),
    regno: yup
        .string()
        .required('Required'),
    address1: yup
        .string()
        .required('Required'),
    countryId: yup
        .string()
        .required('Required'),
    stateId: yup
        .string()
        .required('Required'),
    areaId: yup
        .string()
        .required('Required'),
    postcode: yup
        .string()
        .required('Required'),
    bankName: yup
        .string()
        .required('Required'),
    bankAcc: yup
        .string()
        .required('Required'),
    //    itemId : yup
    //         .string()
    //         .required('Required'),

})

export const initialPasswordValues = {
    password: "",
    passwordconfirm: "",
}

export const initialValues = {
    username: "",
    firstname: "",
    lastname: "",
    contactno: "",
    email: "",

    companyName: "",
    code: "",
    regno: "",
    remark: "",
    status: true,

    address1: "",
    address2: "",
    countryId: "",
    stateId: "",
    areaId: "",
    postcode: "",
    bankName: "",
    bankAcc: "",

}